var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoIncidentWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,18.8L18,18c0.4-0.9,0.6-1.9,0.6-2.9c0-1.3-0.3-2.6-0.9-3.7l-5.2-9.4c-0.2-0.3-0.5-0.5-0.9-0.5c0,0,0,0,0,0 c-0.4,0-0.7,0.2-0.9,0.5L7.5,7.8L7,7.3c-0.2-0.2-0.5-0.2-0.7,0C6.1,7.5,6.1,7.8,6.3,8L7,8.7l-1.5,2.7c-0.6,1.1-0.9,2.4-0.9,3.7 c0,4,3.1,7.3,7,7.3c2.5,0,4.7-1.4,6-3.5l0.5,0.5c0.2,0.2,0.5,0.2,0.7,0C19,19.3,19,19,18.8,18.8z M11.6,2.5l5.2,9.4h0 c0.5,1,0.8,2.1,0.8,3.2c0,0.8-0.1,1.5-0.4,2.1l-9-8.7L11.6,2.5z M11.6,21.5c-3.3,0-6-2.8-6-6.3c0-1.1,0.3-2.2,0.8-3.2l1.4-2.5l9,8.8 C15.8,20.2,13.8,21.5,11.6,21.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoIncidentWater);
export default __webpack_public_path__ + "static/media/picto-incident-water.15fd8de2.svg";
export { ForwardRef as ReactComponent };